import 'core-js/es/map';
import 'core-js/es/set';
import 'raf/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './i18n/i18n';
import './index.css';
import App from './Components/App/App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux'
import store from './Redux/store';
import { PGService } from "./Remote/PowerGym";
import * as Sentry from '@sentry/react';
import ErrorPage from './Components/ErrorPage/ErrorPage';

/**
 * Init Sentry and try to setup the user
 */
try {
    Sentry.init({
        dsn: "https://4d49c550f03f4e939dc580b3f35d0377@o404188.ingest.sentry.io/5267548",
        environment: process.env.REACT_APP_ENVIRONMENT
    });

    const userData = JSON.parse(localStorage.getItem('user'));
    if (userData.dni) {
        Sentry.setUser({ username: userData.dni })
    }
} catch (e) {
    //
}

//Config Instance
PGService.getInstance();

ReactDOM.render(
    <Sentry.ErrorBoundary fallback={ErrorPage} showDialog>
        <Provider store={store}>
            <App />
        </Provider>
    </Sentry.ErrorBoundary>
    , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
